import React from 'react'
// libs
import styled from 'styled-components'
// themes
import { colors } from 'themes'
// static
import ArrowBackOrigin from '@mui/icons-material/ArrowBackIos'
// views
import {
  Accordion as AccordionOrigin,
  AccordionDetails as AccordionDetailsOrigin
} from '../../ObjectsAndProperties/Edit/view'
// utils
import { size } from 'polished'

export const ArrowBack = styled((props) => <ArrowBackOrigin {...props} />)`
  && {
    ${size('12px')};
  }
`

export const IconWrapper = styled('div')`
  align-items: center;
  color: ${colors.blue500};
  cursor: pointer;
  display: flex;
  font-weight: 500;
`

export const Accordion = styled<any>(AccordionOrigin)`
  && {
    padding: 0 16px;
  }
`

export const AccordionDetails = styled(AccordionDetailsOrigin)`
  && {
    padding: 0;
  }
`
